<template>
    <div style="box-shadow: 4px 4px 4px 0px #00000040;" class="auth-data-block bg-[#252526] rounded-[10px] border-[1px] border-[#FFF] border-opacity-10">
        <div class="w-full text-center mt-[10px]">
            <!-- <div class="flex text-center items-center py-[4px] bg-[#BD9135] w-[95%] rounded-[3px] mx-auto">
                <div class="block-title text-[11px] font-bold text-[#252526] text-center mx-auto w-[60%]">ДАНІ ДЛЯ ВХОДУ</div>
            </div> -->
            <div class="bg-[#BD9135] text-[13px] font-bold text-center rounded-[4px] mx-[14px] py-[2px]">
                ДАНІ ДЛЯ ВХОДУ
            </div>
        </div>

        <div class="params-block mx-[15px] text-[#FFF] mt-[2px]">
            <div class="flex justify-between items-center align-middle mb-[10px]">
                <div class="flex">
                    <span class="text-[#FFF] mr-[5px] font-semibold text-[13px]">380</span><input :value="login.replace('380', '')" @change="$emit('update:login', '380' + $event.target.value)" class="text-[#FFF] font-semibold text-[13px] outline-none bg-transparent border-none w-[90%] truncate placeholder:opacity-60" placeholder="000000000" type="text">
                </div>
                <div class="text-[#BD9135] font-normal mt-[4px] opacity-90 text-[11px]">
                    Логін
                </div>
            </div>

            <div class="flex justify-between items-center align-middle mb-[10px]">
                <div class="">
                    <input :value="password" @change="$emit('update:password', $event.target.value)" class="text-[#FFF] font-semibold text-[13px] outline-none bg-transparent border-none w-[70%] truncate placeholder:opacity-60" type="text" placeholder="password">
                </div>
                <div class="text-[#BD9135] mt-[4px] font-normal opacity-90 text-[11px]">
                    Пароль
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DataInput from '../ui/DataInput.vue'

    export default {
        name: 'auth-data-card',

        props: {
            login: {
                type: String,
                default: ''
            },
            password: {
                type: String,
                default: ''
            },
        },

        components: {
            DataInput
        }
    }
</script>

<style lang="scss">

    .params-block {
        // flex items-end justify-between
        display: flex;
        align-items: center;
        justify-content: space-between;

        div {
            width: 40%;

            div:first-child {
                width: 70%;
            }

            div:last-child {
                text-align: right;
            }
        }
    }

    .auth-data-block {
        width: 400px;
        height: 67px;
    }

    @media screen and (max-width: 500px) {
        .params-block {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            margin-top: 10px;

            div {
                width: 100%;

                div:first-child {
                    width: 100%;
                }
            }
        }

        .auth-data-block {
            width: 250px;
            height: 107px;
        }
    }

</style>
    